var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{staticStyle:{"width":"90px"},attrs:{"default-value":_vm.lang},on:{"change":_vm.handleChange}},_vm._l((_vm.languageArr),function(item){return _c('a-select-option',{key:item.value,attrs:{"value":item.value,"select":""}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }